import { jsx as o } from "react/jsx-runtime";
import i from "./Loader.js";
import a from "./NavLink.js";
const d = ({ className: r, isLoading: e, onClick: t }) => e ? /* @__PURE__ */ o(i, {}) : /* @__PURE__ */ o(a, { className: r, level: "tertiary", onClick: t, children: "Load more" });
export {
  d as default
};
